export default __webpack_public_path__ + "static/media/hpeai_1.41177677.jpg";